import React, { useState } from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { UserPlus } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useAuth } from '../context/AuthContext';
import { AuthCard, Field, ErrorBox, GoogleButton, Divider, formatApiError } from '../components/auth/AuthCard';
import { REGISTER } from '../constants/testIds/auth';

export default function RegisterPage() {
  const { register, loginWithGoogle, user } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next') || '/';
  const [form, setForm] = useState({ name: '', email: '', password: '', confirm: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  if (user) return <Navigate to={next} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 8) return setError('ପାସୱାର୍ଡ ଅତି କମରେ ୮ ଅକ୍ଷର ହେବା ଦରକାର / Min 8 characters');
    if (form.password !== form.confirm) return setError('ଦୁଇଟି ପାସୱାର୍ଡ ମେଳ ଖାଉନାହିଁ / Passwords do not match');
    setBusy(true);
    try {
      await register(form.name.trim(), form.email.trim(), form.password);
      navigate(next, { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <AuthCard title="ନୂଆ ଖାତା ଖୋଲନ୍ତୁ" subtitle="ମାଗଣା ଖାତା — Odia ଛାତ୍ର ଓ ଶିକ୍ଷକ ପାଇଁ">
      <GoogleButton onClick={() => loginWithGoogle(next)} />
      <Divider />
      <form onSubmit={submit} className="space-y-3" data-testid="register-form">
        <Field label="ନାମ / Name" required minLength={2} autoComplete="name" testId={REGISTER.nameInput}
          value={form.name} onChange={set('name')} placeholder="ଆପଣଙ୍କ ନାମ" />
        <Field label="ଇମେଲ୍ / Email" type="email" required autoComplete="email" testId={REGISTER.emailInput}
          value={form.email} onChange={set('email')} placeholder="you@example.com" />
        <Field label="ପାସୱାର୍ଡ / Password" type="password" required autoComplete="new-password" testId={REGISTER.passwordInput}
          value={form.password} onChange={set('password')} placeholder="ଅତି କମରେ ୮ ଅକ୍ଷର" />
        <Field label="ପାସୱାର୍ଡ ପୁଣି ଲେଖନ୍ତୁ / Confirm" type="password" required autoComplete="new-password" testId={REGISTER.passwordConfirmInput}
          value={form.confirm} onChange={set('confirm')} placeholder="••••••••" />
        <ErrorBox message={error} testId="register-error" />
        <Button type="submit" disabled={busy} data-testid={REGISTER.submitButton}
          className="w-full h-12 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold gap-2">
          <UserPlus size={16} /> {busy ? 'ଅପେକ୍ଷା କରନ୍ତୁ…' : 'ଖାତା ଖୋଲନ୍ତୁ'}
        </Button>
      </form>
      <p className="text-center text-xs text-gray-600 mt-4">
        ପୂର୍ବରୁ ଖାତା ଅଛି? <Link to="/login" className="text-emerald-700 font-bold" data-testid={REGISTER.loginLink}>ଲଗଇନ କରନ୍ତୁ</Link>
      </p>
      <p className="text-center text-[10px] text-gray-400 mt-3">ଖାତା ଖୋଲିବା ଦ୍ୱାରା ଆପଣ ଆମ <Link to="/privacy" className="underline">Privacy Policy</Link> ମାନିବେ</p>
    </AuthCard>
  );
}
